<template>
    <div class="online_home_page" :style="screenHeight">
      <Row :gutter="8" class="highNumber" v-show="showWoPop">
        <Col span="25">
          <WorkOrderPop ref="workOrderModule" @openCallPhone="openCallPhone" :openId="openId" :showWoPop="showWoPop" @workOrderSave="workOrderSave" @jumpToWorkPage="jumpToWorkPage" @closeWoPop="closeWoPop"></WorkOrderPop>
        </Col>
      </Row>
      <Row :gutter="8" class="highNumber" v-show="!showWoPop">
        <Col span="6">
            <OnlineLeftcon ref="leftModule" @callbackFun="leftCallbackFun" ></OnlineLeftcon>
        </Col>
        <Col span="11" class="highNumber">
           <OnlineMidcon ref="midModule" :openId= "openId" @sendMessage="sendMessage" @callbackFun="midChangeCallbackFun" :ShowService = "showservice"></OnlineMidcon>
        </Col>
        <Col span="7" class="highNumber">
          <OnlineRightcon ref="rightModule" @workOrderBack="workOrderBack" :openId= "openId" @openwo="openwo" @closeWoPop="closeWoPop"></OnlineRightcon>
        </Col>
      </Row>

    </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js';
    import OnlineLeftcon from '@/components/OnlineService/OnlineLeftcon.vue';
    import OnlineMidcon from '@/components/OnlineService/OnlineMidcon.vue';
    import OnlineRightcon from '@/components/OnlineService/OnlineRightcon.vue';
    import WorkOrderPop from '@/components/OnlineService/WorkOrderPop.vue';
    export default {
        name: "OnlineService",
        mixins:[publicFunClass],
        props:{
          showservice:Boolean,
          pageCode:String
        },
        components: {
            OnlineLeftcon,
            OnlineMidcon,
            OnlineRightcon,
            WorkOrderPop
        },
        data(){
          return{
            topLeft:'1',
            topRight:'1',
            bottomLeft:'1',
            bottomRight:'1',
            spinShow: false,
            screenHeight:{height:'','background-color':'rgb(241 241 241)'},
            sessionId:'',  //会话的唯一标识
            openId: '',
            customerType: '', //客户类型
            onlineInfos: null,

            showWoPop:false,
          }
        },
        methods: {
          openCallPhone:function(flag,phone){
            this.$emit("openCallPhone",true,phone,'1');
          },
          workOrderSave:function(){
            this.$refs.rightModule.beforeSave(true);
          },
          workOrderBack:function(flag){
            this.$refs.workOrderModule.saveWorkOrder(flag);
          },
          jumpToWorkPage:function(id,tittle){
            let code = "b_w_1-"+id;
            tittle = tittle.replace(/<[^>]+>/g, "");
            if (tittle && tittle.length > 5) {
              tittle = tittle.substring(0, 5) + "…";
            }
            this.$emit("showStandardPage",code+","+tittle+"",[]);
            let param = {
              pageUuId:code,
            };
            let newGroupList = [];
            newGroupList.push(param)
            this.$store.commit('addWorkOrderReserve',newGroupList);
          },
          initSearch:function () {
            // this.spinShow=true;
          },
          openwo:function(flag){
            if(flag){
              this.showWoPop=true;
            }
          },
          closeWoPop:function(){
            this.showWoPop=false;
            this.$refs.rightModule.changeTabrig('1');
          },
          // 点击左侧待处理客户列表，回调事件
          leftCallbackFun: function(data){
            this.openId = data;
          },
          // 中间按钮功能导致数据改变回调事件
          midChangeCallbackFun: function(openId){
            // 调用左边模块的init方法，重新获取数据
            this.openId="";
            this.$refs.leftModule.init();
            this.$refs.leftModule.resetCurrentId(this.openId);

            this.$refs.midModule.initValue();
          },
          // 发送消息
          sendMessage: function(message){
            this.sendMsg(message);
          },
            // 在线客服向后端发送数据
          sendMsg: function(msg){

            let chatClient = this.$store.getters.getMqClient();
            if (chatClient.connected) {
                chatClient.send("/queue/mpccChatReceiver", {
                    "content-type": "text/plain",
                    "x-message-ttl": "30000"
                }, JSON.stringify(msg));
                this.$store.commit('pushMsg',msg);
            }else{
              console.error("MQ连接失败，不能发送消息");
              this.$Message.error("连接失败，请重新签入");
            }
          },
        },
       created(){
         this.screenHeight.height=this.mountHeight(92);
        //  mq连接
        //  this.connect();
        },
        mounted () {
          this.initSearch();
          this.onlineInfos = this.$store.getters.getOnlineInfos();
          window.midChangeCallbackFun = this.midChangeCallbackFun;
        },
        beforeDestroy() {
          // this.disconnect();
        },
        watch:{
          // 监听数据数组长度变化，对左边和右边的数据进行刷新

          'onlineInfos.length': {
                handler(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        // 操作
                        this.$refs.leftModule.init();
                    }
                }
            },
        }
    }
</script>

<style  lang="less">
    .online_home_page{
      .ivu-tabs-bar{
        margin-bottom: 0px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/OnlineService/OnlineService.vue